function a(t) {
  return this.__data__.get(t);
}
var _ = a;
export {
  _
};
//# sourceMappingURL=_stackGet.js.map
